import { render, staticRenderFns } from "./TheseCreate.vue?vue&type=template&id=0898fbd5&"
import script from "./TheseCreate.vue?vue&type=script&lang=js&"
export * from "./TheseCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports